import {
  AgentType,
  ColFraction,
  ColSpan3,
  ColTitle,
  inputStyle,
  RowSpan,
  SearchButton,
} from "../../assets/GlobalStyles";
import Select from "react-select";
import {
  agentTypeInfo,
  calculationAllType,
  deviceTypeInfo,
  productTypeInfo,
  searchInfo,
  searchMediaTypeAll
} from "../../pages/media_manage/entity/common";
import React, {useState} from "react";
import Checkbox from "./Checkbox";
import styled from "styled-components";
import {SearchUser} from "./SearchUser";

export default function SearchBoard (props) {
  const {productType, deviceType, calculationType, agentType, mediaSearch, searchKeyword, onSearch} = props;
  const [searchInfoState, setSearchInfoState] = useState(searchInfo)
  const [selectedMedia, setSelectedMedia] = useState(null)

  const handleMediaSearchSelected = (item) => {
    setSelectedMedia(item)
    setSearchInfoState(prev => ({
      ...prev,
      searchKeywordType: {id: "2", value: "USERNAME", label: "아이디"},
      keyword: item.username || ""
    }))
  }

  /**
   * 광고 상품 선택
   * @param productType
   */
  const handleProductType = (productType) => {
    setSearchInfoState({
      ...searchInfoState,
      productType: productType
    })
  }

  /**
   * 디바이스 유형 선택
   * @param deviceType
   */
  const handleDeviceType = (deviceType) => {
    setSearchInfoState({
      ...searchInfoState,
      deviceType: deviceType
    })
  }

  /**
   * 정산방식 선택
   * @param calculationType
   */
  const handleCalculationType = (calculationType) => {
    setSearchInfoState({
      ...searchInfoState,
      calculationType: calculationType
    })
    //지면리스트 호출
  }

  /**
   * 에이전트 유형 선택
   * @param agentType
   */
  const handleAgentType = (e) => {
    if(e.target.checked){
      setSearchInfoState({
        ...searchInfoState,
        agentTypes: searchInfoState.agentTypes.concat(e.target.value)
      })
    }else{
      setSearchInfoState({
        ...searchInfoState,
        agentTypes: searchInfoState.agentTypes.filter(type => type !== e.target.value)
      })
    }
  }

  /**
   * 검색타입 선택
   * @param searchMediaType
   */
  const handleSearchMediaTypeAll = (searchMediaType) => {
    setSearchInfoState({
      ...searchInfoState,
      searchKeywordType: searchMediaType,
      keyword: searchMediaType.value !== null ? searchInfoState.keyword : ''
    })
    //지면리스트 호출
  }

  /**
   * 검색어 입력
   * @param event
   */
  const handleSearchName = (event) => {
    setSearchInfoState({
      ...searchInfoState,
      keyword: event.target.value
    })
  }

  const onClickSearch =() => {
    onSearch(searchInfoState)
  }

  return (
    <>
      {mediaSearch &&
        <RowSpan>
          <MediaSearchField>
            <ColTitle><span>매체 검색</span></ColTitle>
            <MediaSearchControl>
              <input
                  type="text"
                  value={selectedMedia?.siteName || ""}
                  placeholder="검색 버튼을 눌러 매체를 선택해 주세요."
                  readOnly
              />
              <SearchUser
                  title="검색"
                  btnStyle="mediaCreate"
                  onSubmit={handleMediaSearchSelected}
              />
            </MediaSearchControl>
          </MediaSearchField>
        </RowSpan>
      }
        {productType &&
            <ColFraction>
              <ColTitle><span>광고 상품</span></ColTitle>
              <Select styles={inputStyle}
                      isSearchable={false}
                      options={productTypeInfo}
                      value={(searchInfoState.productType !== undefined && searchInfoState.productType.value !== '') ? searchInfoState.productType : productTypeInfo[0]}
                      onChange={handleProductType}
              />
            </ColFraction>
        }
        {deviceType &&
          <ColFraction>
            <ColTitle><span>디바이스</span></ColTitle>
            <Select styles={inputStyle}
                    isSearchable={false}
                    options={deviceTypeInfo}
                    value={(searchInfoState.deviceType !== undefined && searchInfoState.deviceType.value !== '') ? searchInfoState.deviceType : deviceTypeInfo[0]}
                    onChange={handleDeviceType}
            />
          </ColFraction>
        }
        {calculationType &&
          <ColFraction>
            <ColTitle><span>정산 방식</span></ColTitle>
            <Select styles={inputStyle}
                    isSearchable={false}
                    options={calculationAllType}
                    value={(searchInfoState.calculationType !== undefined && searchInfoState.calculationType.value !== '') ? searchInfoState.calculationType : calculationAllType[0]}
                    onChange={handleCalculationType}
            />
          </ColFraction>
        }
      {agentType &&
        <RowSpan>
          <ColSpan3>
            <ColTitle><span>에이전트</span></ColTitle>
            <div>
              <AgentType>
                {agentTypeInfo.map(type => {return (
                    <Checkbox label={type.label} type={'c'} id={type.id} value={type.value} onChange={handleAgentType}/>
                )})}

              </AgentType>
            </div>
          </ColSpan3>
        </RowSpan>
      }
      {searchKeyword &&
        <RowSpan>
          <ColSearch className="search-keyword-group">
            <Select styles={SearchStyle}
                    isSearchable={false}
                    options={searchMediaTypeAll}
                    value={(searchInfoState.searchKeywordType !== undefined && searchInfoState.searchKeywordType.value !== null) ? searchInfoState.searchKeywordType : searchMediaTypeAll[0]}
                    onChange={handleSearchMediaTypeAll}
            />
            <SearchInput>
              <input type={'text'}
                     placeholder={searchInfoState.searchKeywordType.value != null ?  '검색어를 입력해 주세요.' : '검색 항목을 선택해 주세요.'}
                     value={searchInfoState.keyword || ""}
                     onChange={handleSearchName}
                     readOnly={(searchInfoState.searchKeywordType.value === '' || searchInfoState.searchKeywordType.value == null) ? true:false}
                     onKeyDown={event => (event.key === 'Enter') && onClickSearch()}
              />
            </SearchInput>
          </ColSearch>
          <SearchButton onClick={onClickSearch}>검색</SearchButton>
        </RowSpan>
      }
    </>
  )
}

const MediaSearchField = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 14px;

  ${ColTitle} {
    width: 92px;
    min-width: 92px;
    margin: 0;
    color: #444;
    font-size: var(--font-size-13);
    font-weight: 700;
  }
`;

const MediaSearchControl = styled.div`
  display: flex;
  width: min(520px, 100%);
  align-items: center;
  gap: 8px;

  input {
    width: 100%;
    height: 38px;
    padding: 0 12px;
    border: 1px solid var(--color-border-strong);
    border-radius: 7px;
    background: var(--color-surface);
    color: var(--color-text);
    font-size: var(--font-size-13);
    outline: none;
  }

  input::placeholder {
    color: #a0a8b2;
  }

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

const ColSearch = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 50%;
  & > div:first-child {
    position: relative;
    width: 30%;
    height: 35px;
  }
  & > div:last-child {
    position: relative;
    width: 100%;
  }
  & > Select {
    width: 10%;
  }
`
const SearchStyle = {
  indicatorSeparator: () => null,
  container: (styles) => ({
    ...styles,
    width: '100%',
  }),
  control: (styles,{isFocused,isDisabled}) => ({
    ...styles,
    backgroundColor: isDisabled ?'#F9FAFB' : 'white',
    border: '1px solid #e5e5e5',
    height: 35,
    minHeight: 35,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: isFocused && `0 0 0 1px var(--color-main)`,
    ':hover': {
      ...styles[':hover'],
      borderColor: isFocused && `var(--color-main)`
    }
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor:
          isDisabled ? undefined :
              isSelected ? `var(--color-main)` :
                  isFocused ? 'var(--color-primary)'
                      :undefined,
      color:
          isDisabled ? '#222' :
              isSelected ? 'var(--color-surface)' : '#222',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled ?
            isSelected ? `var(--color-main)`
                : undefined
            :undefined

      }
    }
  },
  input: (styles) => ({
    ...styles,
    height: 26,
    borderRadius: 5,
  }),
  placeholder: (styles) => ({
    ...styles
  }),
  singleValue: (styles, { data }) => ({
    ...styles
  }),
};

const SearchInput = styled.div`
  position: relative;
  width: 100%;
  & input[type='text'] {
    padding: 0 20px;
    width: 100%;
    height: 35px;
    border: 1px solid #e5e5e5;
    border-left-width: 0;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    &:hover {
      border: 1px solid #b3b3b3;
    }
  }
`
